import React from 'react';
import { Table, Button, Input, Card, message, Popconfirm, Col, Select, TreeSelect} from 'antd';
import common from '../../assets/common.js';
import moment from 'moment';
import MenuAction from '../../modest/menuaction/index.js'
import './index.css';
const Option = Select.Option;
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
class MemberTable extends React.Component {
  delete = (record) => {
    var postData = {};
    postData["_url"] = "";
    postData["_method"] = "DELETE";
    postData["id"] = record.id;
    common.request(postData, this, function(obj, result){
      const pagination = obj.state.table.pagination;
      obj.getList(pagination);
    });
  }
  cancel = (id) =>{
    console.log(id)
  }
  constructor(){
    super();
    let table = {};
    table.id = "proTable";
    table = common.getDefaultTable(table);
    this.state = {
      table,
      batchList : [],
      search : "",
      modalType : "",
      modalData : "",
      visible: false,
      pwdUrl:"",
      key: "",
      openTime: [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
      value: "",
      roomId_other: "",
      example:[],
      selectedRowKeys: []
    }
  }
  componentWillMount(){
    let this_ = this;
    this.showTableCol();
    // console.log(window.localStorage.getItem("userName"));
    if(window.localStorage.getItem("roomId")) {
      let roomId = window.localStorage.getItem("roomId");
      this_.setState({
        roomId,
        roomId_other: roomId,
        value: ['roomId' + roomId]
      },() => {
          this.getArea();
          setTimeout(()=> {
            this.getList();
            // window.localStorage.clear("roomId");
          }, 500);
      })
    }
  }
  componentDidMount(){

  }
  getArea = () => {
    let this_ = this;
    var postData = {};
    if(sessionStorage.getItem("subAdmin")) {
      postData["_url"] = "api/admin/area";
    } else {
      postData["_url"] = "api/dc/access/area";
    }
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data) {
      let ar = data.result.subList.map(function(index){
        let arr1 = [];
        if(index.dcBuildingList.length !== 0) {
          let ar2 = index.dcBuildingList.map(function(item) {
            let arr2 = {};
            if(item.roomList.length !== 0) {
              let ar3 = item.roomList.map(function(dataItem) {
                let arr3 = {};
                arr3["title"] = dataItem.roomName;
                arr3["key"] = "roomId" + dataItem.roomId;
                arr3["id"] = dataItem.roomId;
                arr3["value"] = "roomId" + dataItem.roomId;
                arr3["dept"] = 3;
                let example = this_.state.example;
                example.push(arr3)
                this_.setState({
                  example
                })
                return arr3;
              })
              arr2["children"] = ar3;
            }
            arr2["title"] = item.building;
            arr2["key"] = "buildingId" + item.buildingId;
            arr2["id"] = item.buildingId;
            arr2["value"] = "buildingId" + item.buildingId;
            arr2["dept"] = 2;
            let example = this_.state.example;
            example.push(arr2)
            this_.setState({
              example
            })
            return arr2;
          });
          arr1["children"] = ar2;
        }
        arr1["title"] = index.areaName;
        arr1["key"] = "areaId" + index.areaId;
        arr1["id"] = index.areaId;
        arr1["value"] = "areaId" + index.areaId;
        arr1["dept"] = 1;
        let example = this_.state.example;
        example.push(arr1)
        this_.setState({
          example
        })
        return arr1;
      });
      // console.log(this_.state.example);
      obj.setState({
        treeData: ar
      })
    }, function(obj, state) {

    })
  }
  showTableCol = () => {
    let table = this.state.table;
    let status = {
      "UN_ACTIVATED": "未激活",
      "MORMAL": "正常",
      "ACTIVATED_FAIL": "失败",
      "DEL": "已删除"
    };
    table.columnsList = [{
      title: '姓名',
      dataIndex: 'userName',
      must: false,
      show: true,
      width: '80px'
    }, {
      title: '学工号',
      dataIndex: 'cardNo',
      must: false,
      show: true,
      width: '100px',
    }, {
      title: '部门',
      dataIndex: 'deptName',
      must: false,
      show: true,
      width : "120px"
    }, {
      title: '区域',
      dataIndex: 'doorName',
      must: false,
      show: true,
      width : "120px"
    }, {
      title: '下发状态',
      dataIndex: 'status',
      must: true,
      show: true,
      width : "120px",
      render: (text, record) => {

        return (
          <span>{status[record.status]}</span>
        )
      }
    }];
    table = common.getEcardTable(table);
    // console.log(table);
    this.setState({ table });
  }
  changePage = (pagination, filters, sorter) => {
    const table = this.state.table;
    table.pagination = pagination;
    this.setState({ table })
    this.getList(pagination.current)
  }
  thisOk = () => {
    this.getList();
  }
  getList = (pageInfo, filters, sorter) =>{
    var this_ = this;
    const pn = pageInfo ? pageInfo: 1;
    const table = this.state.table;
    let roomIds = [];
    let buildings = [];
    let areaIds = [];
    this.state.example.map((item) => {
      if(this_.state.value.indexOf(item.value) > -1) {
        if(item.dept === 3) {
          roomIds.push(item.id);
        } else if(item.dept === 2){
          buildings.push(item.id);
        } else {
          areaIds.push(item.id);
        }
      }
    });
    var postData = {};
    postData["_url"] = "api/whitelist/search";
    postData["pageNum"] = pn;
    postData["pageSize"] = this.state.table.pagination.pageSize;
    if(this.state.userName !== "") {
      postData["userName"] = this.state.userName;
    }
    if(this.state.cardNo !== "") {
      postData["cardNo"] = this.state.cardNo;
    }
    // if(this.state.deptName != "") {
    //   postData["deptName"] = this.state.deptName;
    // }
    if(this.state.status !== 1) {
      postData["status"] = this.state.status;
    }
    if(roomIds.length > 0) {
      postData["roomIds"] = roomIds;
    }
    if(buildings.length > 0) {
      postData["buildingIds"] = buildings;
    }
    if(areaIds.length > 0) {
      postData["areaIds"] = areaIds;
    }
    table.loading = true;
    this.setState({ table });
    common.request(postData, this, function(obj, data){
      const result = data.result;
      obj.showList(result, pn);
    },function(obj, state){
      table.loading = false;
      obj.setState({ table });
    });
  }
  showList = (result, pn) => {
    const table = this.state.table;
    const list = result.list;
    table.loading = false;
    var dataSource = [];
    table.pagination = {
      current : pn,
      pageSizeOptions: ["10","20","30","40","50"],
      total : result.pageInfo.resultAmount,
    }
    common.eachObj(list, function(index, dataItem){
      var one = dataItem;
      one["key"] = dataItem.id;
      one["orgId"] = dataItem.orgId;
      one["orgName"]= dataItem.orgName;
      one["userName"] = dataItem.userName;
      dataSource.push(one);
    })
    table.dataSource = dataSource;
    this.setState({ table });
  }
  showModal = (modalType, modalData) => {
    switch(modalType){
      case "releaseend":case "importend":
        this.getList();
        this.setState({ modalType, modalData });
        break;
      default:
        this.setState({ modalType, modalData });
        break;
    }
  }
  handleSearch = (selectedKeys, confirm) => () => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = clearFilters => () => {
    clearFilters();
    this.setState({ searchText: '' });
  }
  handleCancel = ()=> {
    this.setState({
      visible: false
    });
  }
  onChange = (date, dateString) => {
    let this_ = this;
    if(dateString[0] !== "") {
      let arr = [];
      arr[0] = dateString[0] + ":00";
      arr[1] = dateString[1] + ":00";
      this_.setState({
        openTime: arr
      })
    } else {
      this_.setState({
        openTime: ''
      })
    }
  }
  handleChangeStatus = (value) => {
    this.setState({
      status: value
    })
  }
  setUserName = (e) => {
    this.setState({
      userName: e.target.value
    })
  }
  setCardNo = (e) => {
    this.setState({
      cardNo: e.target.value
    })
  }
  onChangeTree = (value) => {
    // console.log(value);
    this.setState({ value });

  }
  onSelectChange = selectedRowKeys => {
    // console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.setState({ selectedRowKeys });
  }
  deletePeople = () => {
    var postData = {};
    postData["_url"] = "api/whitelist/batchdel";
    postData["ids"] = this.state.selectedRowKeys;
    common.request(postData, this, function(obj, result){
      message.info(result.message);
      obj.getList();
    },function(obj, data){
      message.warning(data.message);
    });
  }
  repeatPeople = () => {
    var postData = {};
    postData["_url"] = "api/whitelist/batchrepeat";
    postData["ids"] = this.state.selectedRowKeys;
    common.request(postData, this, function(obj, data){
      message.info(data.message);
      obj.getList();
    },function(obj, data){
      message.warning(data.message);
    });
  }
  returnBack = () => {
    this.props.history.push("/manage/area");
    // window.localStorage.setItem('roomId', this.state.roomId_other);
  }
  // setDeptName = (e) => {
  //   this.setState({
  //     deptName: e.target.value
  //   })
  // }
  render(){
    const { table, selectedRowKeys  } = this.state;
    const hasSelected = selectedRowKeys.length > 0
    const tProps = {
      treeData: this.state.treeData,
      allowClear: true,
      value: this.state.value,
      onChange: this.onChangeTree,
      treeCheckable: true,
      showCheckedStrategy: SHOW_PARENT,
      searchPlaceholder: '请选择区域',
      style: {
        width:320
      },
    };
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    return(
      <Card>
        <div>
          <div className="table-menu clearfix">
            <div className="pull-left">
              <Col span={8}>
                <label>姓&emsp;&emsp;名：</label>
                <Input style={{width:200}} placeholder="请输入姓名" value={ this.state.userName } onChange={ this.setUserName }/>
              </Col>
              <Col span={8}>
                <label>学 工 号：{" "}</label>
                <Input style={{width:200}} placeholder="请输入学工号" value={ this.state.cardNo } onChange={ this.setCardNo }/>
              </Col>
              <Col span={8}>
                <label>区&emsp;&emsp;域：</label>
                <TreeSelect {...tProps} style={{width:200}}/>
              </Col>
              <Col span={8}>
                  <label>下发状态：</label>
                <Select style={{ width: 100,marginTop: 15 }} placeholder="全部" onChange={ this.handleChangeStatus }>
                  <Option value={1}>全部</Option>
                  <Option value="UN_ACTIVATED">未激活</Option>
                  <Option value="MORMAL">正常</Option>
                  <Option value="ACTIVATED_FAIL">失败</Option>
                  <Option value="DEL">已删除</Option>
                </Select>
              </Col>
              <Col span={8} style={{marginTop: 15}}>
                <Button type="primary" onClick={ this.thisOk }>查询</Button>
                <Button type="primary" style={{marginLeft: 15}} onClick={ this.returnBack }>返回</Button>
              </Col>
              <Col span={12} style={{marginTop: 15}}>

              </Col>
            </div>
            <div className="pull-left" style={{minWidth: 500}}>
              <Popconfirm title="确定要删除用户吗？" okText="是" cancelText="否" onConfirm={() => this.deletePeople()}>
                <Button type="primary" disabled={!hasSelected}>
                  批量删除
                </Button>
              </Popconfirm>
              <Popconfirm title="确定要重发用户吗？" okText="是" cancelText="否" onConfirm={() => this.repeatPeople()}>
                <Button type="primary" style={{marginLeft: 15}} disabled={!hasSelected}>
                  批量重发
                </Button>
              </Popconfirm>
            </div>
            <div className="pull-right">
            { table.show && <MenuAction obj={ this }/> }
            </div>
          </div>
          <div id="manageTableDiv" className="table-div">
            { table.show && <Table rowSelection={rowSelection}
              { ...table }
              onChange={this.changePage.bind(this)}
            />}
            <div className="table-total">共{ table.pagination.total }条数据</div>
          </div>

        </div>
      </Card>
    )
  }
}
export default MemberTable;



// WEBPACK FOOTER //
// ./src/component/manage/pass.js